<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="700"
  >
    <v-card>
      <v-card-title class="text-h3 pt-6 text-center">
        {{ $t('label.hello_flag', lang) }}
      </v-card-title>

      <v-card-text>
        <span class="text-h6 my-5 text-center d-block black--text">
          {{ $t('label.message_geustplan_available_in_local_lang', lang) }}
        </span>
      </v-card-text>

      <v-card-actions>
        <v-spacer />
        <v-btn
          color="success"
          @click="switchToNewLanguage"
        >
          {{ $t('button.yes', lang) }}
        </v-btn>
        <v-btn
          color="error"
          text
          @click="emit('close')"
        >
          {{ $t('button.cancel', lang) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import i18n from '@/plugins/i18n';
import storage from '@/services/local-storage';
import { ref } from 'vue';

const props = defineProps({
  lang: { type: String, required: true },
});
const emit = defineEmits(['close']);

const dialog = ref(true);

const switchToNewLanguage = () => {
  i18n.locale = props.lang;
  storage.setLanguage(props.lang);
};

storage.setLanguagePromptDisplayed(true);

</script>
